var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSunshadeClosedSmall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    fill: "currentColor",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M24,0H8C6.3457031,0,5,1.3457031,5,3v26c0,1.6542969,1.3457031,3,3,3h16c1.6542969,0,3-1.3457031,3-3V3 C27,1.3457031,25.6542969,0,24,0z M25,29c0,0.5517578-0.4482422,1-1,1H8c-0.5517578,0-1-0.4482422-1-1V3 c0-0.5517578,0.4482422-1,1-1h16c0.5517578,0,1,0.4482422,1,1V29z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 22,
    width: 14,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 18,
    width: 14,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 14,
    width: 14,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 26,
    width: 14,
    height: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5,8H15v4h2V8h1.5c0.1943359,0,0.3701172-0.1123047,0.453125-0.2880859 c0.0820312-0.1757812,0.0556641-0.3828125-0.0693359-0.5322266l-2.5-3c-0.1894531-0.2285156-0.578125-0.2285156-0.7675781,0l-2.5,3 c-0.125,0.1494141-0.1513672,0.3564453-0.0693359,0.5322266C13.1298828,7.8876953,13.3056641,8,13.5,8z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSunshadeClosedSmall);
export default __webpack_public_path__ + "static/media/sunshade-closed--small.eefa0c3d7ed40df59484587df2d1e677.svg";
export { ForwardRef as ReactComponent };